const convertNumber = (number: number, fixed?: number) => {
  const afterDecimalStr = number.toString().split('.')[1] || '';

  return afterDecimalStr.length > fixed ? Number(number.toFixed(fixed)) : number;
};

export default convertNumber;
